import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { User, Users } from '@models/user';
import { TokenService, UpdatePasswordData } from '@services/token-service';
import { TranslateModule } from '@ngx-translate/core';
import { I18nPlaceholderDirective, I18nValueDirective } from '../../directives/i18n.directives';

@Component({
  selector: 'lv-edit-profile',
  templateUrl: 'edit-profile.component.html',
  styleUrls: ['edit-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, FormsModule, I18nPlaceholderDirective, I18nValueDirective]
})
export class EditProfileComponent implements OnInit {
  private userService = inject(Users);
  private tokenService = inject(TokenService);
  private router = inject(Router);

  user: User;
  updates: UpdatePasswordData;

  passwordsAreSame(): boolean {
    return this.updates.password === this.updates.passwordConfirmation;
  }

  ngOnInit() {
    this.user = this.userService.currentUser();
    this.reset();
  }

  reset() {
    this.updates = {
      password: '',
      passwordConfirmation: ''
    };
  }

  valid(form: NgForm): boolean {
    return form.valid && this.passwordsAreSame();
  }

  updatePassword() {
    this.tokenService.updatePassword(this.updates).subscribe(
      () => this.router.navigateByUrl('/'),
      () => this.reset()
    );
  }
}
